<div class="container-div d-flex flex-column">
  <div class="heading-div d-flex flex-column">
    <span class="heading">
      Are you sure you want to approve this FC merge?
    </span>
    <span class="sub-heading">
      Please select two or more FCs that you want to approve merge for
    </span>
  </div>
  <div class="fc-div d-flex flex-column">
    @for(item of data.fc;track item){
    <div class="fc-details d-flex flex-column">
      <div class="fc">
        <label class="custom-checkbox">
          <input type="checkbox" (change)="onCheckboxChange(item)" />
          <span class="checkmark"></span>
        </label>

        <span class="sub-text">{{ item.familyCode }}</span>
      </div>
      <div class="d-flex justify-content-between">
        <span class="mem-details">Member</span>
        <span class="sub-heading">{{ item.phlName }}</span>
      </div>
    </div>

    }
  </div>
  <div class="comment-div">
    <div class="comments d-flex justify-content-between">
      <span class="sub-heading"> Add Comments *</span>
      <!-- <span class="count">{{ count }}/120</span> -->
    </div>
    <textarea
      class="dp-input-control comment-inp"
      type="textarea"
      [formControl]="comments"
    ></textarea>
  </div>

  <div class="btn-div d-flex flex-column">
    @if(checkCount>=1){
    <button class="btn-content dp-primary-btn" (click)="onApproveClick()">
      <span>Approve selected & merge</span></button
    >}
    <button class="dp-tertiary-btn btn-cancel" mat-dialog-close>
      No, Cancel
    </button>
  </div>
</div>
